// extracted by mini-css-extract-plugin
export var ActionButton = "Hero-module--ActionButton--5BwZ1";
export var Actions = "Hero-module--Actions--rTTc9";
export var Headline = "Hero-module--Headline--+4CYN";
export var Hero = "Hero-module--Hero--gQ3np";
export var PlayBtn = "Hero-module--PlayBtn--ivA0J";
export var Restart = "Hero-module--Restart--oRvg6";
export var Schedule = "Hero-module--Schedule--GIgSp";
export var SilentAnimation = "Hero-module--SilentAnimation--VDUUf";
export var Words = "Hero-module--Words--qtjJL";